// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import auth from 'menu-items/auth';
import cadastros from 'menu-items/cadastros';
import cofre from 'menu-items/cofre';
import financeiro from 'menu-items/financeiro';
import comercial from 'menu-items/comercial';
import crm from 'menu-items/crm';
import colaboradores from 'menu-items/colaboradores';
import cultura from 'menu-items/cultura';
import helpdesk from 'menu-items/helpdesk';
import projetos from 'menu-items/projetos';
import notificacoes from 'menu-items/notificacoes';
import admin from 'menu-items/admin';
import main from 'menu-items/main';
import minhaArea from 'menu-items/minhaArea';
import { useLocation } from 'react-router-dom';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const location = useLocation();
  const pathname = location.pathname;

  let currentMenu;
  if (pathname.startsWith('/auth')) currentMenu = { items: [auth] };
  else if (pathname.startsWith('/cadastros')) currentMenu = { items: [cadastros] };
  else if (pathname.startsWith('/cofre')) currentMenu = { items: [cofre] };
  else if (pathname.startsWith('/financeiro')) currentMenu = { items: [financeiro] };
  else if (pathname.startsWith('/comercial')) currentMenu = { items: [comercial] };
  else if (pathname.startsWith('/crm')) currentMenu = { items: [crm] };
  else if (pathname.startsWith('/colaboradores')) currentMenu = { items: [colaboradores] };
  else if (pathname.startsWith('/cultura')) currentMenu = { items: [cultura] };
  else if (pathname.startsWith('/helpdesk')) currentMenu = { items: [helpdesk] };
  else if (pathname.startsWith('/projetos')) currentMenu = { items: [projetos] };
  else if (pathname.startsWith('/notificacoes')) currentMenu = { items: [notificacoes] };
  else if (pathname.startsWith('/admin')) currentMenu = { items: [admin] };
  // O portal do colaborador tem grupo próprio — e endereço próprio, FORA de /colaboradores: o
  // guard daquele grupo libera por prefixo, e a role Colaborador enxergaria as telas do RH.
  else if (pathname.startsWith('/minha-area')) currentMenu = { items: [minhaArea] };
  else currentMenu = { items: [main] };

  const navGroups = currentMenu.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
